/**
 * @module geo/actions/creators
 *
 */
import { promiseActionCreator } from "../../helpers/observable.to.promise";
import { GO_TO_MARKER, REMOVE_MARKERS } from "../../payload/facade";
import { ADD_MARKERS } from "../../payload/facade/ADD_MARKERS";
import { Acknowledged } from "../../payload/response/acknowledged";
import { AddMarkersDone } from "../../payload/response/addmarkers.done";
import { RemoveMarkersDone } from "../../payload/response/remove.markers.done";
import { actionCreator } from "../helpers/actions.creator.builder";
import { ActionCreator } from "../helpers/fsa";
import { TypeKeyActions } from "../types.key.action";

/**
 * return an action creator to add markers on a map
 * @since v 2.0.1
 */
export const addMarkersCreator = actionCreator<ADD_MARKERS>(
  TypeKeyActions.ADD_MARKERS
) as ActionCreator<ADD_MARKERS>;
/**
 * action types for addMarkersCreator
 * @since v 2.0.1
 */
export const addMarkersAsyncCreator = actionCreator.async<
  ADD_MARKERS,
  AddMarkersDone,
  Error
>(TypeKeyActions.ADD_MARKERS);
/**
 * return an  async action to add markers  on the current map
 * @since v 2.0.1
 * @private
 * @hidden
 */
export const addMarkersCreatorP = promiseActionCreator(addMarkersCreator, [
  addMarkersAsyncCreator.done.type,
  addMarkersAsyncCreator.failed.type
]);

/**
 * return an action creator to go to a marker
 * @since v 2.0.1
 */
export const gotoMarkerCreator = actionCreator<GO_TO_MARKER>(
  TypeKeyActions.GO_TO_MARKER
) as ActionCreator<GO_TO_MARKER>;
/**
 * action type to gotoMarkerCreator
 * @since v 2.0.1
 */
export const gotoMarkerAsyncCreator = actionCreator.async<
  GO_TO_MARKER,
  Acknowledged,
  Error
>(TypeKeyActions.GO_TO_MARKER);
/**
 * return an  action creator  with a promise  action to localize map around a
 * marker
 * @since v 2.0.1
 */
export const gotoMarkerCreatorP = promiseActionCreator(gotoMarkerCreator, [
  gotoMarkerAsyncCreator.done.type,
  gotoMarkerAsyncCreator.failed.type
]);

export const removeMarkersCreator = actionCreator<REMOVE_MARKERS>(
  TypeKeyActions.REMOVE_MARKERS
) as ActionCreator<REMOVE_MARKERS>;
/**
 * action type to removeMarkersCreator
 *
 * @since v 2.0.1
 */
export const removeMarkersAsyncCreator = actionCreator.async<
  REMOVE_MARKERS,
  RemoveMarkersDone,
  Error
>(TypeKeyActions.REMOVE_MARKERS);
/**
 *  return an  async action permitting to remove markers
 *  @since v 2.0.1
 */
export const removeMarkersCreatorP = promiseActionCreator(
  removeMarkersCreator,
  [removeMarkersAsyncCreator.done.type, removeMarkersAsyncCreator.failed.type]
);
